module.exports = __webpack_public_path__ + "static/img/avatar.26816ab3.png";